import React from 'react';
import { OutputRenderer } from '../../dashboard/OutputRenderer.js';

interface OutputPartsSectionProps {
  parts: Array<Record<string, unknown>>;
}

export const OutputPartsSection: React.FC<OutputPartsSectionProps> = ({ parts }) => {
  if (!parts.length) return null;

  return (
    <div className="space-y-3">
      <h4 className="text-xs font-semibold text-muted uppercase tracking-wide">Output Parts</h4>
      <div className="space-y-2">
        {parts.map((part, i) => (
          <OutputRenderer
            key={`${String(part.kind ?? 'part')}-${String(part.key ?? i)}`}
            output={{
              kind: String(part.kind ?? 'artifact'),
              title: String(part.title ?? part.key ?? part.kind ?? 'Output'),
              payload: (typeof part.payload === 'object' && part.payload !== null
                ? part.payload
                : { value: part.payload }) as Record<string, unknown>,
              payloadUrl: part.payloadUrl as string | undefined,
            }}
          />
        ))}
      </div>
    </div>
  );
};
